
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stack",
      function () {
        return require("private-next-pages/stack/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stack"])
      });
    }
  